module.exports = __webpack_public_path__ + "static/media/the-farms-being-run-from-space.3e88f0a8.jpg";